import { useCoreInput } from "@Shared/@Composables/inputs/useCoreInput";
import BaseRadio from "@Shared/components/form-elements/base/base-checkbox.vue";
import { defineComponent, toRefs } from "@vue/composition-api";
import { uniqueId } from "lodash";
import BaseLabel from "../base/base-label.vue";
import BaseFieldLayout from "../base/base-field-layout.vue";
export default defineComponent({
  name: "CheckboxField",
  components: {
    BaseLabel,
    BaseFieldLayout,
    BaseRadio
  },
  props: {
    value: {
      type: Boolean,
      default: null
    },
    id: {
      type: String,
      default: () => uniqueId()
    },
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    optionLabel: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Object,
      default: null
    },
    sideGrid: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const {
      value
    } = toRefs(props);
    const {
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput,
      valueModel
    } = useCoreInput({
      value
    });
    return {
      valueModel,
      hasFocus,
      handleBaseFocus,
      handleBaseBlur,
      handleBaseChange,
      handleBaseInput
    };
  }
});